<custom-popup [subtitle]="''" [showClose]="false" [title]="''" [id]="NonstpPopUpData.Id"
    [config]="NonstpPopUpData.Config">
    <div class="modal-body">
        <div class="row bottom-margin-20">
            <div class="col-sm-12">
                <div>
                    <span class="fontStyle" *ngIf="nextTaskKey !== 'tpNonStp'">Sorry, Currently we’re unable to serve
                        you on our online platform. Please get in touch with nearest Bajaj
                        Allianz office to insure your vehicle – Thanks!</span>
                    <span class="fontStyle" *ngIf="nextTaskKey == 'tpNonStp'">If you wish to renew with TP policy please
                        select “yes” & if you wish to renew with CP, please select No</span>
                    <br />
                    <div class="center-block top-margin-20 text-center">
                        <button id="btnReject" class="btn btn-primary right-margin-10"
                            (click)="nextTaskKey == 'tpNonStp' ? continueToJourney() : reject()">{{nextTaskKey ==
                            'tpNonStp' ? 'Yes' : 'Ok'}}</button>
                        <button id="btnCancel" class="btn btn-default"
                            (click)="nextTaskKey == 'tpNonStp' ? reject() : continueToJourney()">{{nextTaskKey ==
                            'tpNonStp' ? 'No' : 'Cancel'}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</custom-popup>